<div fxLayout fxLayoutAlign="center">
    <div
        ngClass.gt-xs="user-card"
        [ngStyle.gt-xs]="{ backgroundColor: data?.background.color }"
    >
        <div
            fxLayout="row"
            fxLayoutAlign="space-between end"
            [ngStyle.gt-xs]="{ marginRight: '35px', marginLeft: '40px' }"
        >
            <div fxLayout="column">
                <h1 ngClass.gt-xs="member-header-text-desktop">{{
                    data?.header?.text
                }}</h1>
                <h1 style="font-size: 16px; margin-bottom: 21px">
                    {{ data?.header?.title?.text }}</h1
                >
                <p
                    [ngStyle]="{
                        color: data?.header.subtitle.color
                    }"
                    style="margin: 0%; line-height: 22px"
                    [innerHTML]="data?.header?.subtitle?.text | lineBreak"
                >
                </p>
            </div>
            <div ngClass.gt-xs="member-header-sub-desktop" fxLayout="column">
            </div>
        </div>
        <div fxLayout="column" [ngStyle]="{ marginBottom: '35px' }">
            <h1
                [ngStyle.gt-xs]="{ color: data?.details?.title.color }"
                ngClass.gt-xs="member-header-subtext-desktop"
                >{{ data?.details?.title.text }}</h1
            >
            <p ngClass.gt-xs="user-member-footer-desktop">
                {{ data?.details?.subtext }}</p
            >
        </div>
        <div
            *ngIf="data?.cta"
            fxLayout
            class="bottom-button-card"
            fxLayoutAlign="center"
        >
            <button
                [disabled]="data?.cta?.link === null"
                (click)="processLink(data?.cta?.link)"
                mat-raised-button
                color="primary"
                class="call-to-action-button"
            >
                {{ data?.cta?.text }}
            </button>
        </div>
    </div>
</div>
